const map = {
	"./blacksmall.jpg": 63,
	"./contacts.jpg": 9278,
	"./docs.jpg": 9216,
	"./docs0.jpg": 810,
	"./docs1.jpg": 5271,
	"./filigran.png": 5833,
	"./flotteauto.jpg": 6898,
	"./header1024.png": 2303,
	"./loginbk1.png": 3526,
	"./logooskala0.png": 5723,
	"./nfc.jpg": 7266,
	"./planning.jpg": 9270,
	"./rapports.jpg": 5230,
	"./rapports0.jpg": 1748,
	"./scan.png": 6734,
	"./slide0.jpg": 4960,
	"./slide1.jpg": 5885,
	"./slide3.jpg": 9295,
	"./smartphone-frame-0.png": 483,
	"./smartphone-frame.png": 3140,
	"./tablet-frame.png": 1141,
	"./wave.png": 1338
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4433;